
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { MobileProductMenu } from './MobileProductMenu';
import { MobileHomepageMenu } from './MobileHomepageMenu';
import { NavItem } from './types';

interface MobileNavigationMegaMenuItemProps {
  item: NavItem;
  expanded: { [key: string]: boolean };
  onToggleExpand: (label: string) => void;
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const MobileNavigationMegaMenuItem: React.FC<MobileNavigationMegaMenuItemProps> = ({
  item,
  expanded,
  onToggleExpand,
  onClose,
  onNavigationClick
}) => {
  const renderMegaMenuContent = () => {
    if (item.label === 'Homepage') {
      return <MobileHomepageMenu onClose={onClose} onNavigationClick={onNavigationClick} />;
    }
    if (item.label === 'Products') {
      return <MobileProductMenu onClose={onClose} onNavigationClick={onNavigationClick} />;
    }
    return null;
  };

  return (
    <div>
      <button
        className={`flex items-center justify-between w-full text-gray-700 px-3 py-4 text-lg font-semibold transition-colors active:scale-95 ${
          expanded[item.label] ? 'bg-blue-50 text-blue-600' : 'hover:text-blue-600 hover:bg-gray-100 active:bg-gray-200'
        }`}
        onClick={() => {
          onToggleExpand(item.label);
        }}
        aria-expanded={expanded[item.label] || false}
        style={{ 
          minHeight: 48, 
          minWidth: 48, 
          touchAction: 'manipulation'
        }}
      >
        <span>{item.label}</span>
        <ChevronDown
          className={`ml-1 h-5 w-5 transition-transform duration-150 ${expanded[item.label] ? 'rotate-180' : ''}`}
          aria-hidden="true"
        />
      </button>
      {expanded[item.label] && (
        <div className="pt-2 pb-3">
          {renderMegaMenuContent()}
        </div>
      )}
    </div>
  );
};
